import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            探索漫画分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            六种题材分类，助你快速找到最爱的韩漫类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-50 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${category.icon} text-sm text-white`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-white font-heading">{category.name}</h3>
                </div>
                <p className="text-sm text-white/70 mb-2">{category.description}</p>
                <span className="text-xs text-white/50">{category.count.toLocaleString()} 部作品</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}